import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Notification, { NOTIFICATION_TYPE } from '../../components/notification'

import ResponseNotificationAction from '../../actions/response-notification'

export default function withResponseNotification(ChildComponent) {

    class withResponseNotificationWrapper extends Component {
        static propTypes = {
            dispatch: PropTypes.func.isRequired,
            responseNotification: PropTypes.array
        }

        constructor(props) {
            super(props)

            this.state = {
                notification: {
                    type: NOTIFICATION_TYPE.success
                }
            }

            this.dismissNotificationAlert = this.dismissNotificationAlert.bind(this)
        }

        componentWillReceiveProps(nextProps) {
            const { responseNotification } = nextProps
            const notification = responseNotification.length ?
                responseNotification[responseNotification.length - 1] :
                this.state.notification

            this.setState({ notification })
        }

        dismissNotificationAlert() {
            this.setState({
                notification: {
                    type: this.state.notification.type
                }
            }, () => this.props.dispatch(ResponseNotificationAction.dismiss()))
        }

        render() {
            const { responseNotification, ...otherProps } = this.props // eslint-disable-line no-unused-vars
            const {
                notification: {
                    raw: {
                        response: {
                            data: { error, message } = {}
                        } = {}
                    } = {},
                    displayMessage,
                    show,
                    type
                }
            } = this.state

            const notificationContent = displayMessage || error || message

            return (
                <div>
                    <ChildComponent {...otherProps} />
                    <Notification
                        bsStyle={type}
                        dismissable
                        onDismiss={this.dismissNotificationAlert}
                        show={!!show && !!notificationContent}
                        showFullText
                        timeout={type === 'danger' ? 0 : null}
                    >
                        {notificationContent}
                    </Notification>
                </div>
            )
        }
    }

    return connect(mapStateToProps)(withResponseNotificationWrapper)
}

const mapStateToProps = (state) => {
    const { responseNotification } = state

    return {
        responseNotification
    }
}




// WEBPACK FOOTER //
// src/containers/high-order-components/with-response-notification.js